export default "__VITE_ASSET__Bp$uR13s__"